import React from "react";
import { useState, useEffect, useFormContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Sale } from "models/SaleModel";
import { SaleOrder } from "models/SaleOrderModel";
import { SaleItem } from "models/SaleItemModel";
import AsyncSelect from "react-select/async";
import { HtmlDataFormat } from "components/common/HtmlFormat"
import { Extract } from "helpers/ExtractHelper";
import DrawingPad from "components/common/DrawingPad";
import { FormList } from "models/BaseModel";
import { MediaList } from 'models/BaseModel';
import { useSearchParams, useParams } from 'react-router-dom';



const SaleForm: React.FC = () => {
  const widthOrder = { clientname: 20, clientpay: 9, insurance1: 9, insurance2: 9, frame:9, highindex:8,  gift: 8, cradd:9, cruse:9, total: 10 }
  const widthItem = { product: 46, type: 10, price: 10,  discount: 10, gst:10, amount: 10 }
  const [formId, formName] = [Code.Form.Id.SALE, Code.Form.Name.SALE];
  const {keyId, setKeyId, activeId, setActiveId, loading, setLoading, hasUnsaved, setHasUnsaved, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [insurerOptions, setInsurerOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Sale>({});
  const [initialData, setInitialData] = useState<Sale>({});
  const [saleOrderData, setSaleOrderData] = useState<SaleOrder[]>([]); 
  const [saleItemData, setSaleItemData] = useState<SaleItem[]>([]); 
  const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [canvasWidth, setCanvasWidth] = useState<Number>(800); 
  const [drawingPad1, setDrawingPad1] = useState<string | null>(''); 
  const [drawingPad2, setDrawingPad2] = useState<string | null>(''); 
  const [drawingChange1, setDrawingChange1] = useState<boolean>(false); 
  const [drawingChange2, setDrawingChange2] = useState<boolean>(false); 
  const [fileList, setFileList] = useState<MediaList>({});
  const { keyId: paramKeyId } = useParams<{ keyId: string }>();

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
   
  useEffect(() => {
   Files.Json.API(Code.File.DOCTOR, Code.Option.Common.NA, setDoctorOptions, setError);
    Files.Json.API(Code.File.INSURER, Code.Option.Common.NA, setInsurerOptions, setError);
    Files.Json.Http(Code.File.SEGMENT, Code.Option.Common.SELECT, setSegmentOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.ORDER_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    
    API.Data.GetByKeyId<Sale>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.sale_active); 
        const clientData = await API.Data.getClientNameNumber(data.client_id);
        const formData = await Form.Map.Data(data);
        const finalData = {
          ...formData,
          ...clientData, 
        };
        setFormData(finalData);
        setInitialData(finalData);
        Utility.Storage.Set(Code.Form.Name.SALE,data.sale_id);
        await saleOrderList(data.sale_id);
        await saleItemList(data.sale_id);
        await Files.List.ParseFile(data.file_list, setFileList);
        
        const parsedData: MediaList = JSON.parse(data.file_list!);
        console.log("fileList-=-=-=->",data.file_list, parsedData);

        const docName1 = parsedData?.document1;
        if (docName1) {
          const imageData1 = await Files.File.Content(docName1, "notepad");
          if (imageData1) {
            setDrawingPad1(imageData1);
          }
        }

        const docName2 = parsedData?.document2;
        if (docName2) {
          const imageData2 = await Files.File.Content(docName2, "notepad");
          if (imageData2) {
            setDrawingPad2(imageData2);
          }
        }
        setLoading(false);
        
      }})

      const onNewEntry = async () => {
          if(keyId===Code.Key.NEW && clientId) {
            const clientName = await API.Data.GetClientName(Number(clientId));
            const newData = {
              client_id: Number(clientId),
              client_name: Utility.Value.Text(clientName), 
            };
            setFormData(newData);
            setInitialData(newData);
          }
          setLoading(false);
        };
        onNewEntry();
      
  }, []);

  useEffect(() => { 
    const hasChanged = JSON.stringify(formData) !== JSON.stringify(initialData);
    setHasUnsaved(hasChanged); 
  }, [formData, initialData]);

  const saleOrderList = async (saleId: number | undefined) => {
    if (!saleId) return;  
      const url = API.Build.FormApiEndpint(Code.Form.Name.SALEORDER, 200, Name.SaleOrder.Id, Code.Option.Sort.ASC, {
      fields: Utility.Join.Fields([
        Name.SaleOrder.Id, 
        Name.Sale.Id,
        Name.Client.Id,
        Name.Client.FullName,
        Name.Common.TypeName,
        Name.Common.StatusName,
        Name.Common.CreditName,
        Name.SaleOrder.ClientAmount,
        Name.SaleOrder.Insurer1Amount,
        Name.SaleOrder.Insurer2Amount,
        Name.SaleOrder.FrameAmount,
        Name.SaleOrder.HighIndexAmount,
        Name.SaleOrder.GiftAmount,
        Name.SaleOrder.CreditAdd,
        Name.SaleOrder.CreditUse,
        Name.SaleOrder.Payable,
        Name.SaleOrder.Data,
      ]),
      [Name.Sale.Id]: saleId,
    });
    await API.Data.List<SaleOrder>(url, setSaleOrderData, setError, setLoading);
  };


  useEffect(() => {
    console.log("formData-------------->",formData)
  }, [formData]);

  useEffect(() => {
    console.log("saleItemData-------------->",saleItemData)
  }, [saleItemData]);

  useEffect(() => {
    console.log("drawingChange1-------------->",drawingChange1)
    if(drawingChange1){
      setHasUnsaved(true);
    }
  }, [drawingChange1]);

  useEffect(() => {
    console.log("drawingChange2-------------->",drawingChange2)
    if(drawingChange2){
      setHasUnsaved(true);
    }
  }, [drawingChange2]);

  const saleItemList = async (saleId: number | undefined) => {
    if (!saleId) return;  
      const url = API.Build.FormApiEndpint(Code.Form.Name.SALEITEM, 200, Name.SaleItem.Id, Code.Option.Sort.ASC, {
      fields: Utility.Join.Fields([
        Name.SaleItem.Id, 
        Name.Sale.Id,
        Name.SaleOrder.Id,
        Name.Product.Name,
        Name.Common.TypeName,
        Name.SaleItem.Utncode,
        Name.SaleItem.Skucode,
        Name.SaleItem.Price,
        Name.SaleItem.Quantity,
        Name.SaleItem.Gross,
        Name.SaleItem.DiscountAmount,
        Name.SaleItem.DiscountPercentage,
        Name.SaleItem.Tax1Amount,
        Name.SaleItem.Tax1Percentage,
        Name.SaleItem.NetAmount,
        Name.SaleItem.Data,
        Name.Specification.Id,
      ]),
      [Name.Sale.Id]: saleId,
    });
    await API.Data.List<SaleItem>(url, setSaleItemData, setError, setLoading);
  };

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;

    let newFileList: MediaList = { ...fileList };

    if(drawingChange1 && drawingPad1){
      const drawData1: File = await dataURLtoFileAsync(drawingPad1, 'drawing1.png');
      //const uploadedFile1 = await Files.ImageAPI.Attach(drawData1, canvasWidth, setError);
      //const uploadedFile1 = await Files.File.Attach(drawData1, "notepad", setError);
      const uploadedFile1 = await Files.Photo.Attach(drawData1, "notepad", 929, setError);
      console.log("uploadedFile---->",uploadedFile1);
      newFileList.document1 = uploadedFile1;
    }

    if(drawingChange2 && drawingPad2){
      const drawData2: File = await dataURLtoFileAsync(drawingPad2, 'drawing2.png');
      //const uploadedFile2 = await Files.File.Attach(drawData2, "notepad", setError);
      const uploadedFile2 = await Files.Photo.Attach(drawData2, "notepad", 929, setError);
      console.log("uploadedFile---->",uploadedFile2);
      newFileList.document2 = uploadedFile2;
    }

    console.log("newFileList----->",newFileList);

    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      file_list: JSON.stringify(Files.List.Clean(newFileList)),
    });

    console.log("finalData----->",finalData);

    setDrawingChange1(false);
    setDrawingChange2(false);
    
    const response = await API.Data.Save(formName, keyId, finalData, setMessage, true, Code.Form.PopupClose.REMAINOPEN);
    if(response){

      if (keyId === Code.Key.NEW) {
        const localKeyId = response.data[Code.Key.NEWID];
        const localNewId = Extract.Key.Decode(localKeyId);
        setKeyId(localKeyId);
        setActiveId(Code.Option.Active.ACTIVE);
        Utility.Storage.Set(Code.Form.Name.SALE,localNewId);
        setFormData((prev) => ({
          ...prev,
          sale_id: localNewId,
          sale_key: localKeyId,
        }));
     }

      setInitialData(formData);
      setHasUnsaved(false);
    }

  };

  const getAmount = (Amount: string | number | undefined ) => {
    return Utility.Format.Amount(Amount).replace(".00","")
  };



const onRefresh = async () => {
  console.log("refreshed");
  if (paramKeyId) {
    await saleOrderList(Number(paramKeyId));
    await saleItemList(Number(paramKeyId));
  }
};

  const generateForm = async (saleOrderId: number | undefined, identity: string) => {
    console.log("generate order:", saleOrderId, identity);
    const response = await API.Data.generateForm(saleOrderId, identity, setMessage);
    if(response){
      console.log(`${identity} generate response:`, response);
      Utility.Message.Info([`${identity.replace(/\d/g, '')} Generated successfully`],setMessage);
      await onRefresh();
    }
  };  

  const generatePayment = () => {
    Utility.Message.Warning([`To add this payment, open the invoice and click the [+Payment] button.`],setMessage);
  };  

  async function dataURLtoFileAsync(dataURL: string, filename: string): Promise<File> {
      const res = await fetch(dataURL);
      const blob = await res.blob();
      return new File([blob], filename, { type: blob.type });
  }

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} hasUnsaved={hasUnsaved} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} formId={formId} Privilege={Privilege} print={true} />
          <Control.Tab.Header titles={["Details", "Writing"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Sale.Date} value={formData.sale_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]} require={true} currentDate={true} />
                <Field.Text id={Name.Sale.Number} value={formData.sale_number} title={Title.SNo} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,20,1]} />
                <Field.FilterSelect id={Name.Doctor.Id} value={formData.doctor_id} title={Title.Doctor} options={doctorOptions} setFormData={setFormData} size={[1,20,1]} />
                <Field.FilterSelect id={Name.Common.SegmentId} value={formData.segment_id} title={Title.Segment} options={segmentOptions} setFormData={setFormData} require={true} size={[1,20,1]} />
                <Field.FilterSelect id={Name.Common.StatusId} value={formData.status_id} title={Title.State} options={statusOptions} setFormData={setFormData} size={[1,20,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.FormOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header>
              </Control.Row>
              {keyId!== Code.Key.NEW && (
                <>
                  <Control.ButtonColumn>
                    <Button.Action title={'+ Add New Order'} info={'Click here to add new order'} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.SALEORDER, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.Segment, formData.segment_id)} animation={false} />
                  </Control.ButtonColumn>
                  <Control.Form.Table>
                    <Control.Form.Title>
                      <Control.Grid.Items values={[
                        ['Client Name', widthOrder.clientname], 
                        ['Client', widthOrder.clientpay, Code.Align.RIGHT], 
                        ['Ins.1', widthOrder.insurance1, Code.Align.RIGHT], 
                        ['Ins.2', widthOrder.insurance2, Code.Align.RIGHT], 
                        ['Case', widthOrder.frame, Code.Align.RIGHT], 
                        ['HIndex', widthOrder.highindex, Code.Align.RIGHT],
                        ['Gift', widthOrder.gift, Code.Align.RIGHT],
                        ['Cr.Add', widthOrder.cradd, Code.Align.RIGHT],
                        ['Cr.Use', widthOrder.cruse, Code.Align.RIGHT],
                        ['Total', widthOrder.total, Code.Align.RIGHT]
                      ]} first={2} />
                    </Control.Form.Title>
                    <Control.Form.List>
                      {saleOrderData.map((order, index) => { return (
                        <Control.Form.Index key={index} index={index}>
                          <Control.Form.Item>
                            <Control.Grid.Modify path={Utility.Join.Edit(Privilege, Code.Form.Name.SALEORDER, order.saleorder_id)} iframeRef={iframeRef} Privilege={Privilege} />
                            <Control.Grid.HashLink hashId={order.saleorder_id} />
                            <Control.Grid.Items values={[
                              [Utility.Get.FullName(order, Code.Form.Name.CLIENT), widthOrder.clientname],
                              [getAmount(order.saleorder_client_amount), widthOrder.clientpay, Code.Align.RIGHT],
                              [getAmount(order.saleorder_insurer1_amount), widthOrder.insurance1, Code.Align.RIGHT],
                              [getAmount(order.saleorder_insurer2_amount), widthOrder.insurance2, Code.Align.RIGHT],
                              [getAmount(order.frame_amount), widthOrder.frame, Code.Align.RIGHT],
                              [getAmount(order.highindex_amount), widthOrder.highindex, Code.Align.RIGHT],
                              [getAmount(order.gift_amount), widthOrder.gift, Code.Align.RIGHT],
                              [getAmount(order.credit_add_amount), widthOrder.cradd, Code.Align.RIGHT],
                              [getAmount(order.credit_use_amount), widthOrder.cruse, Code.Align.RIGHT],
                              [getAmount(order.saleorder_payable_amount), widthOrder.total, Code.Align.RIGHT],
                            ]} />
                          </Control.Form.Item>
                        </Control.Form.Index>
                      )})}
                    </Control.Form.List>
                    <Control.Form.Footer>
                      <Control.Grid.Items values={[
                        ['Total', widthOrder.clientname], 
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.saleorder_client_amount || 0), 0)), widthOrder.clientpay, Code.Align.RIGHT], 
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.saleorder_insurer1_amount || 0), 0)), widthOrder.insurance1, Code.Align.RIGHT], 
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.saleorder_insurer2_amount || 0), 0)), widthOrder.insurance2, Code.Align.RIGHT], 
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.frame_amount || 0), 0)), widthOrder.frame, Code.Align.RIGHT], 
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.highindex_amount || 0), 0)), widthOrder.highindex, Code.Align.RIGHT],
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.gift_amount || 0), 0)), widthOrder.gift, Code.Align.RIGHT],
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.credit_add_amount || 0), 0)), widthOrder.cradd, Code.Align.RIGHT],
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.credit_use_amount || 0), 0)), widthOrder.cruse, Code.Align.RIGHT],
                        [getAmount(saleOrderData.reduce((sum, o) => sum + (o.saleorder_payable_amount || 0), 0)), widthOrder.total, Code.Align.RIGHT]
                      ]} first={2} />
                    </Control.Form.Footer>
                  </Control.Form.Table>
                  <Control.Row>
                    <Field.Area id={Name.Sale.Comment} value={formData.sale_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
                  </Control.Row>
                  <Control.Box>
                    {saleOrderData.map((order, orderIndex) => {
                      const currentItems = saleItemData?.filter((d) => d.saleorder_id === order.saleorder_id) || [];

                      let dataObject: FormList = {};
                      let isOrderGenerated =  false;
                      try {
                        const jsonData = order.saleorder_data;
                        if(jsonData){
                          const parsed = JSON.parse(jsonData);
                          if (typeof parsed === "object" && !Array.isArray(parsed)) {
                            dataObject = parsed;
                            isOrderGenerated = dataObject.order1 != null && dataObject.order1.id != 2;
                          }
                        }
                        
                      } catch (err) { console.error("Invalid JSON in saleorder_data:", order.saleorder_data); }

                      return (
                        <>
                          <Control.Grid.HashTarget hashId={order.saleorder_id} />
                          <Control.Form.BoxPanel key={orderIndex} index={orderIndex}>
                            
                            <Control.Row>
                              <Field.Text id={Name.Client.FullName} value={Utility.Get.FullName(order, Code.Form.Name.CLIENT)} title={Title.ClientName} size={[0,40,1]} disabled={true} />
                              <Field.Text id={Name.Common.CategoryName} value={order.credit_name} title={Title.Category} size={[1,20,1]} disabled={true} />
                              <Field.Text id={Name.Common.TypeName} value={order.type_name} title={Title.Type} size={[1,20,1]} disabled={true} />
                              <Field.Text id={Name.Common.StatusName} value={order.status_name} title={Title.State} size={[1,20,0]} disabled={true} />
                            </Control.Row>
                          
                            <Control.ButtonColumn>
                              <Button.Action title="+ Frame" info={Info.AddProduct} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.SALEITEM, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.SaleOrder, order.saleorder_id, Code.UrlPara.Product, Code.Option.Product.FRAME)}  animation={false} color={2}  />
                              <Button.Action title="+ Lens" info={Info.AddProduct} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.SALEITEM, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.SaleOrder, order.saleorder_id, Code.UrlPara.Product, Code.Option.Product.LENS)}  animation={false} color={1}  />
                              <Button.Action title="+ Prescription" info={Info.AddProduct} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.SALEITEM, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.SaleOrder, order.saleorder_id, Code.UrlPara.Product, Code.Option.Product.PRESCRIPTION)}  animation={false} color={10}  />
                              <Button.Action title="+ CL" info={Info.AddProduct} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.SALEITEM, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.SaleOrder, order.saleorder_id, Code.UrlPara.Product, Code.Option.Product.CL)}  animation={false} color={3}  />
                              <Button.Action title="+" info={Info.AddProduct} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.SALEITEM, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.SaleOrder, order.saleorder_id)}  animation={false} color={8} />
                              <Button.Action title={'Edit Order'} info={Info.AddProduct} onClick={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.SALEORDER, order.saleorder_id))} animation={false} className="fright mr0" />
                            </Control.ButtonColumn>
                            <Control.Form.Table>
                              <Control.Form.Title>
                                <Control.Grid.Items values={[
                                  ["Product/Specifications", widthItem.product], 
                                  [Title.Type, widthItem.type, Code.Align.RIGHT], 
                                  ['Price/Qty.', widthItem.price, Code.Align.RIGHT], 
                                  [Title.Discount, widthItem.discount, Code.Align.RIGHT],
                                  [Title.GST, widthItem.gst, Code.Align.RIGHT],
                                  [Title.Amount, widthItem.amount, Code.Align.RIGHT]
                                ]} first={1} />
                              </Control.Form.Title>
                              <Control.Form.List>
                                {currentItems.map((item, itemIndex) => (
                                  <Control.Form.Index key={itemIndex} index={itemIndex}>
                                    <Control.Form.OrderTextArea 
                                      path={`${Utility.Join.Edit(Privilege, Code.Form.Name.SALEITEM, item.saleitem_id)}?${Code.UrlPara.Client}=${order.client_id}`} 
                                      iframeRef={iframeRef} 
                                      index={itemIndex} 
                                      specification={item.specification_id}
                                      data={HtmlDataFormat(item.specification_id, item.saleitem_data)}
                                      productName={item.product_name} 
                                      utncode={item.saleitem_utncode}
                                      skucode={item.saleitem_skucode} 
                                      frameStatus={Utility.Remove.NA(item.type_name)}
                                      price={item.saleitem_price}
                                      quantity={item.saleitem_quantity}
                                      discAmount={item.saleitem_discount_amount}
                                      discPercentage={item.saleitem_discount_percentage}
                                      tax1Amount={item.saleitem_tax1_amount}
                                      tax1Percentage={item.saleitem_tax1_percentage}
                                      netAmount={item.saleitem_net_amount}
                                    />
                                  </Control.Form.Index>
                                ))}
                              </Control.Form.List>
                            </Control.Form.Table>
                            <Control.Flex>
                              <Control.Column size={[0,20,0,1]}><></></Control.Column>
                              <Control.Column size={[0,80,0,1]}>
                                <Control.Row>
                                  <Field.Title title={"Total"} size={[0,18,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.saleorder_payable_amount} size={[1,16,1]} alignRight={true} disabled={true}  />
                                  <Field.Title title={"Client Pay"} size={[0,17,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.saleorder_client_amount} size={[1,16,1]} alignRight={true} disabled={true} />
                                  <Field.Title title={"Credit Use"} size={[0,17,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.CreditUse} value={order.credit_use_amount} size={[1,16,0]} alignRight={true} disabled={true} />
                                </Control.Row>
                                <Control.Row>
                                  <Field.Title title={"Frame"} size={[0,18,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.frame_amount} size={[1,16,1]} alignRight={true} disabled={true} />
                                  <Field.Title title={"High Index"} size={[0,17,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.highindex_amount} size={[1,16,1]} alignRight={true} disabled={true} />
                                  <Field.Title title={"Credit Add"} size={[0,17,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.credit_add_amount} size={[1,16,0]} alignRight={true} disabled={true} />
                                </Control.Row>
                                <Control.Row>
                                  <Field.Title title={"Gift Card"} size={[0,18,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.gift_amount} size={[1,16,1]} alignRight={true} disabled={true} />
                                  <Field.Title title={"Insurance 1"} size={[0,17,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.saleorder_insurer1_amount} size={[1,16,1]} alignRight={true} disabled={true} />
                                  <Field.Title title={"Insurance 2"} size={[0,17,1]} align={Code.Align.RIGHT} />
                                  <Field.Text id={Name.SaleOrder.Payable} value={order.saleorder_insurer2_amount} size={[1,16,0]} alignRight={true} disabled={true} />
                                </Control.Row>
                              </Control.Column>
                            </Control.Flex>
                            
                            <Control.ButtonColumn>
                              {Object.entries(dataObject).map(([key, {id,status}], i) => (
                                <>
                                  {key.includes("order1") ? (<Button.AutoGenerateButton isOrderGenerated={true} title={"Order"} amount={order.saleorder_payable_amount} IdValue={{id,status}} onGenerate={() => generateForm(order.saleorder_id, "order1")} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.ORDERS, id))} />) : 
                                  key.includes("invoice1") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Invoice"} amount={order.saleorder_payable_amount} IdValue={{id,status}} onGenerate={() => generateForm(order.saleorder_id, "invoice1")} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.INVOICE, id))} />) :
                                  key.includes("proforma1") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Proforma"} amount={order.saleorder_payable_amount} IdValue={{id,status}} onGenerate={() => generateForm(order.saleorder_id, "proforma1")} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.PROFORMA, id))} />) :
                                  key.includes("dispense1") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Dispense"} amount={order.saleorder_payable_amount} IdValue={{id,status}} onGenerate={() => generateForm(order.saleorder_id, "dispense1")} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.DISPENSE, id))} />) :
                                  key.includes("estimate1") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Estimate"} amount={order.saleorder_payable_amount} IdValue={{id,status}} onGenerate={() => generateForm(order.saleorder_id, "estimate1")} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.ESTIMATE, id))} />) :
                                  key.includes("delivery1") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Delivery"} amount={order.saleorder_payable_amount} IdValue={{id,status}} onGenerate={() => generateForm(order.saleorder_id, "delivery1")} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.DELIVERY, id))} />) :
                                  key.includes("payment1") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Payment"} amount={order.saleorder_client_amount} IdValue={{id,status}} onGenerate={() => generatePayment()} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.PAYMENT, id))} />) : 
                                  key.includes("payment2") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Payment"} amount={order.saleorder_insurer1_amount} IdValue={{id,status}} onGenerate={() => generatePayment()} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.PAYMENT, id))} />) :
                                  key.includes("payment3") ? (<Button.AutoGenerateButton isOrderGenerated={isOrderGenerated} title={"Payment"} amount={order.saleorder_insurer2_amount} IdValue={{id,status}} onGenerate={() => generatePayment()} onView={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, Code.Form.Name.PAYMENT, id))} /> ) : 
                                  (null)}
                                </>
                              ))}
                            </Control.ButtonColumn>
                            
                          </Control.Form.BoxPanel>
                        </>
                      );
                    })}
                  </Control.Box>
                </>
              )}
            </Control.Tab.Content>
            
            <Control.Tab.Content id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
              <>
                <DrawingPad ratio={125} drawingPadData={drawingPad1} setDrawingPadData={setDrawingPad1} setCanvasWidth={setCanvasWidth} setDrawingChange={setDrawingChange1} />
                <DrawingPad ratio={125} drawingPadData={drawingPad2}  setDrawingPadData={setDrawingPad2} setCanvasWidth={setCanvasWidth} setDrawingChange={setDrawingChange2} />
              </>
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} print={true} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={onRefresh} />
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default SaleForm;